import {Typography} from "@mui/material"
import Grid from "@mui/material/Grid"
import {Trans, useTranslation} from "react-i18next"

import {Page} from "@indebted/components/Page"

function LowOutstandingBalance() {
	const {t} = useTranslation()
	return (
		<Page>
			<Grid>
				<Typography align="center" variant="h6">
					{t("customer_get.low_outstanding_balance.title")}
				</Typography>
			</Grid>

			<Grid>
				<Typography align="center">
					<Trans i18nKey="customer_get.low_outstanding_balance.message" />
				</Typography>
			</Grid>
		</Page>
	)
}

export {LowOutstandingBalance}
